import { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { useBudget } from "./useBudget";

const BOUNDARY_INTERVAL_MS = 15 * 60 * 1000;

const msUntilNextBoundary = (): number => {
  const now = new Date();
  const totalMs =
    now.getMinutes() * 60 * 1000 +
    now.getSeconds() * 1000 +
    now.getMilliseconds();
  const msSinceLastBoundary = totalMs % BOUNDARY_INTERVAL_MS;
  return msSinceLastBoundary === 0
    ? BOUNDARY_INTERVAL_MS
    : BOUNDARY_INTERVAL_MS - msSinceLastBoundary;
};

export const useBudgetSync = () => {
  const queryClient = useQueryClient();

  useBudget({ refetchOnWindowFocus: "always", staleTime: Infinity });

  useEffect(() => {
    const invalidate = () =>
      queryClient.invalidateQueries({ queryKey: ["usage-budget"] });

    let intervalId: ReturnType<typeof setInterval>;

    const timeoutId = setTimeout(() => {
      invalidate();
      intervalId = setInterval(invalidate, BOUNDARY_INTERVAL_MS);
    }, msUntilNextBoundary());

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [queryClient]);
};
